export function references(options = {}) {
  const referenceLinkSelector = options.referenceLinkSelector || '.reference-link';
  const referenceItemSelector = options.referenceItemSelector || '.reference-item';
  const referenceLinks = document.body.querySelectorAll(referenceLinkSelector);
  const referenceItems = document.body.querySelectorAll(referenceItemSelector);

  referenceItems.forEach(function(el, i) {
    el.id = 'sr-reference-' + String(i + 1);
  });

  referenceLinks.forEach(function(el, i) {
    el.href = '#sr-reference-' + String(i + 1);
    el.addEventListener('click', function() {
      referenceLinks.forEach(function(el) {
        el.classList.remove('active');
      });
      el.classList.add('active');
    });
  });
}
